// Dados mock para visual bonito antes de ligar no Firestore
export const resumoMock = {
  totalAnuncios: 128,
  visitasSite: 684,
  atendimentos: 142,
  visitasAgendadas: 36,
  fechamentos: 12,
  clientesRecorrentes: 9,
};

export const mensalMock = [
  { mes: 'Jan', atendimentos: 62, visitas: 25, fechamentos: 4 },
  { mes: 'Fev', atendimentos: 58, visitas: 22, fechamentos: 5 },
  { mes: 'Mar', atendimentos: 74, visitas: 29, fechamentos: 6 },
  { mes: 'Abr', atendimentos: 69, visitas: 24, fechamentos: 4 },
  { mes: 'Mai', atendimentos: 81, visitas: 31, fechamentos: 7 },
  { mes: 'Jun', atendimentos: 77, visitas: 28, fechamentos: 6 },
  { mes: 'Jul', atendimentos: 88, visitas: 34, fechamentos: 8 },
  { mes: 'Ago', atendimentos: 95, visitas: 37, fechamentos: 9 },
  { mes: 'Set', atendimentos: 72, visitas: 26, fechamentos: 5 },
  { mes: 'Out', atendimentos: 86, visitas: 33, fechamentos: 7 },
  { mes: 'Nov', atendimentos: 79, visitas: 30, fechamentos: 6 },
  { mes: 'Dez', atendimentos: 65, visitas: 23, fechamentos: 4 },
];

export const funilMock = [
  { etapa: 'Contatos', valor: 320 },
  { etapa: 'Visitas', valor: 150 },
  { etapa: 'Negócios', valor: 36 },
  { etapa: 'Encerrados', valor: 18 },
  { etapa: 'Reincidentes', valor: 12 },
];

export const financeiroMock = [
  { mes: 'Jan', valor: 32000 },
  { mes: 'Fev', valor: 28000 },
  { mes: 'Mar', valor: 41000 },
  { mes: 'Abr', valor: 35000 },
  { mes: 'Mai', valor: 52000 },
  { mes: 'Jun', valor: 47000 },
  { mes: 'Jul', valor: 58000 },
  { mes: 'Ago', valor: 62000 },
  { mes: 'Set', valor: 39000 },
  { mes: 'Out', valor: 54000 },
  { mes: 'Nov', valor: 50000 },
  { mes: 'Dez', valor: 36000 },
];

export function formatBRL(v) {
  return (v ?? 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}
